import { motion } from "framer-motion";

/**
 * Reveal — mask-clip line reveal from the bottom.
 * Perfect for stacking on H1 lines to create the "on-load" signature moment.
 * Usage: <Reveal delay={0.05}><span>Line 1</span></Reveal>
 */
export function Reveal({ children, delay = 0, duration = 0.9, className = "", as: Tag = "span" }) {
  const MotionTag = motion[Tag] || motion.span;
  return (
    <MotionTag
      style={{ display: "inline-block", overflow: "hidden", verticalAlign: "top" }}
      className={className}
    >
      <motion.span
        style={{ display: "inline-block", willChange: "transform" }}
        initial={{ y: "110%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          delay,
          duration,
          ease: [0.22, 1, 0.36, 1], // custom "expo-out" — feels editorial
        }}
      >
        {children}
      </motion.span>
    </MotionTag>
  );
}

/**
 * Rise — subtle upward fade-in triggered when the element enters viewport.
 * Preferred for section-level scroll reveals.
 */
export function Rise({ children, delay = 0, y = 24, duration = 0.8, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ delay, duration, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
